/* RAWAQ — Luxe behaviour for Journal, articles, pages, 404 (23 Oct). AR (rtl) + EN (ltr).
   Without JS every page stays fully readable (FAQ answers open, no hidden content). */
(function(){
  var b=document.body; if(!b||!b.classList.contains('rx')) return;
  b.classList.add('rx-lx','rx-js');
  var root=document.querySelector('.rq'), ltr=root&&root.getAttribute('dir')==='ltr';
  var reduce=!!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches);
  function txt(el){ return (el&&el.textContent||'').replace(/\s+/g,' ').trim(); }
  var rte=document.querySelector('.rx-rte');

  /* bottles: each product image inside an arch with the rising sun */
  [].forEach.call(document.querySelectorAll('.rx-rte p[style*="flex"] img'),function(i){
    var s=document.createElement('span'); s.className='rx-bottle'; i.parentNode.insertBefore(s,i); s.appendChild(i);
  });

  /* closing statement + FAQ accordion */
  var STOP=['الخلاصة','In short'], FAQ=['أسئلة بتتسأل كتير','Frequently asked questions'];
  function accordion(qs){
    if(!qs.length) return;
    var wrap=document.createElement('div'); wrap.className='rx-faq'; qs[0].parentNode.insertBefore(wrap,qs[0]);
    qs.forEach(function(h){
      var d=document.createElement('details'), s=document.createElement('summary'), n=h.nextElementSibling;
      wrap.appendChild(d); d.appendChild(s); s.appendChild(h);
      while(n && n.tagName!=='H3' && n.tagName!=='H2'){ var nx=n.nextElementSibling; d.appendChild(n); n=nx; }
    });
  }
  if(rte){
    [].forEach.call(rte.querySelectorAll('h3'),function(h){
      if(STOP.indexOf(txt(h))>-1){ h.classList.add('rx-sum__h'); var p=h.nextElementSibling; if(p&&p.tagName==='P') p.classList.add('rx-sum'); }
    });
    var page=document.querySelector('.rx-page--faq');
    if(page){
      accordion([].slice.call(rte.querySelectorAll(':scope > h3')));
    } else {
      var head=[].filter.call(rte.querySelectorAll(':scope > h3'),function(h){ return FAQ.indexOf(txt(h))>-1; })[0];
      if(head){
        var qs=[], n=head.nextElementSibling;
        while(n){ if(n.tagName==='H3'){ if(STOP.indexOf(txt(n))>-1) break; qs.push(n); } else if(n.tagName==='H2') break; n=n.nextElementSibling; }
        accordion(qs);
      }
    }
  }

  /* reveal on scroll */
  if(!reduce && 'IntersectionObserver' in window){
    var els=[].slice.call(document.querySelectorAll('.rx-card,.rx-art__fig,.rx-bottle,.rx-more__h'));
    els.forEach(function(e){
      e.classList.add('rx-rv');
      if(e.classList.contains('rx-card')&&e.parentNode){ var k=[].indexOf.call(e.parentNode.children,e); e.style.setProperty('--rd',((k%3)*0.12).toFixed(2)+'s'); }
    });
    var io=new IntersectionObserver(function(es){ es.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } }); },{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  /* article: reading line + hero drifting inside its arch */
  var body=document.querySelector('.rx-art .rx-rte'), hero=document.querySelector('.rx-art__hero img');
  if(body||hero){
    var bar=null, sp=null;
    if(body){ bar=document.createElement('div'); bar.className='rx-progress'; bar.setAttribute('aria-hidden','true'); bar.innerHTML='<span></span>'; sp=bar.firstChild; if(ltr) sp.style.transformOrigin='left center'; b.appendChild(bar); }
    var busy=false;
    var upd=function(){
      busy=false; var vh=window.innerHeight||1;
      if(sp){ var r=body.getBoundingClientRect(); var p=(vh*0.25-r.top)/Math.max(1,r.height-vh*0.5); p=Math.max(0,Math.min(1,p)); sp.style.transform='scaleX('+p.toFixed(3)+')'; }
      if(hero&&!reduce){ var h=hero.getBoundingClientRect(); if(h.bottom>-60&&h.top<vh+60){ var q=(h.top+h.height/2-vh/2)/vh; q=Math.max(-1,Math.min(1,q)); hero.style.setProperty('--py',(q*-30).toFixed(1)+'px'); } }
    };
    window.addEventListener('scroll',function(){ if(!busy){ busy=true; requestAnimationFrame(upd); } },{passive:true});
    window.addEventListener('resize',upd); upd();
  }
})();
